export default "__VITE_ASSET__CozRE$Ek__"